import _regeneratorRuntime from '@babel/runtime/helpers/esm/regeneratorRuntime';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import { getV3Authorizer } from './authorizer.js';
import { getAuthHeadersGetter } from './getAuthHeadersGetter.js';
import { getPlaybackSources } from './getPlaybackSources.js';
import '@dtvgo/utils';
import '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import '@babel/runtime/helpers/esm/slicedToArray';
import '../utils.js';
import '@dtvgo/player-common-utils';

var _excluded = ["authorization", "refreshToken", "drmId", "drms", "manifest"];

/**
 * @typedef PlaybackInfo
 * @type {object}
 * @property {import('./getPlaybackSources').Source[]} sources - The sources to play.
 * @property {() => void} clearRefreshTimeout - Function to clear the refresh timeout.
 */

/**
 * Retrieves playback information with an authorizer using the V3 API.
 *
 * @param {object} backendService - The backend service object.
 * @param {import('./authorizer').AuthorizerV3Params} params - The parameters object.
 * @param {object} options - The options object.
 * @param {(error: Error) => void} options.onAuthorizerError - Function to handle authorizer errors.
 * @param {number} [options.refreshSecondsBefore] - The number of seconds before refreshing.
 * @return {Promise<PlaybackInfo>} A promise that resolves to the playback information.
 */
function getPlaybackInfoWithAuthorizerV3(_x, _x2, _x3) {
  return _getPlaybackInfoWithAuthorizerV.apply(this, arguments);
}
function _getPlaybackInfoWithAuthorizerV() {
  _getPlaybackInfoWithAuthorizerV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(backendService, /* params: */_ref, /* options: */_ref2) {
    var isLive, contentId, getDelay, getIsMobileNetwork, onAuthorizerError, refreshSecondsBefore, _yield$backendService, _yield$backendService2, authorization, refreshToken, drmId, drms, manifest, rest, issuedAt, authorizer, _getAuthHeadersGetter, getAuthHeaders, clearRefreshTimeout, sources;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isLive = _ref.isLive, contentId = _ref.contentId, getDelay = _ref.getDelay, getIsMobileNetwork = _ref.getIsMobileNetwork;
          onAuthorizerError = _ref2.onAuthorizerError, refreshSecondsBefore = _ref2.refreshSecondsBefore;
          _context.next = 4;
          return backendService.entitlement.v3.getTokenAuthorizer({
            delay: (getDelay === null || getDelay === void 0 ? void 0 : getDelay()) || 0,
            mobileNetwork: (getIsMobileNetwork === null || getIsMobileNetwork === void 0 ? void 0 : getIsMobileNetwork()) || false,
            isLive: isLive,
            contentId: contentId
          });
        case 4:
          _yield$backendService = _context.sent;
          _yield$backendService2 = _yield$backendService.data;
          authorization = _yield$backendService2.authorization;
          refreshToken = _yield$backendService2.refreshToken;
          drmId = _yield$backendService2.drmId;
          drms = _yield$backendService2.drms;
          manifest = _yield$backendService2.manifest;
          rest = _objectWithoutProperties(_yield$backendService2, _excluded);
          issuedAt = Date.now();
          authorizer = getV3Authorizer(backendService, {
            isLive: isLive,
            contentId: contentId,
            getDelay: getDelay,
            getIsMobileNetwork: getIsMobileNetwork
          });
          _getAuthHeadersGetter = getAuthHeadersGetter({
            initialData: {
              accessToken: authorization,
              refreshToken: refreshToken,
              issuedAt: issuedAt
            },
            authorizer: authorizer,
            onError: onAuthorizerError,
            refreshSecondsBefore: refreshSecondsBefore
          }), getAuthHeaders = _getAuthHeadersGetter.getAuthHeaders, clearRefreshTimeout = _getAuthHeadersGetter.clearRefreshTimeout;
          sources = getPlaybackSources({
            playbackInfo: {
              drmId: drmId,
              drms: drms,
              manifest: manifest
            },
            getAuthHeaders: getAuthHeaders
          });
          return _context.abrupt("return", _objectSpread(_objectSpread({}, rest), {}, {
            sources: sources,
            clearRefreshTimeout: clearRefreshTimeout
          }));
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getPlaybackInfoWithAuthorizerV.apply(this, arguments);
}

export { getPlaybackInfoWithAuthorizerV3 };
//# sourceMappingURL=getPlaybackInfo.js.map
